import { SxProps } from '@mui/material/styles';
import { ReactNode, useState } from 'react';
import Chip from '../chip';
import { AutoCompleteInputVariant } from '.';
import { AdvancedAutoComplete } from './adavanced-autoComplete';

interface ISelectOption<TOption> {
    freeContent?: ReactNode;
    label: string;
    value: TOption;
}

interface IAutocompleteSearchProps<TOption> {
    label?: string;
    scrollToTitle?: boolean;
    selected?: Array<ISelectOption<any>>;
    wrapperClassName?: string;
    onSelectedRemove?: (option: any) => void;
    onSearch: (searchText: string, signal?: AbortSignal) => Promise<TOption[]>;
    placeholder?: string;
    labelKey?: keyof TOption;
    onChange: (value: TOption) => void;
    needDict?: boolean;
    startAdornmentSx?: SxProps;
    uniqueIdentifier: string;
    error?: boolean;
    loading?: boolean;
    chipClassName?: string;
    selectedOptionsClassName?: string;
    popoverHelper?: ReactNode;
    inputVariant?: AutoCompleteInputVariant;
    popoverInputVariant?: AutoCompleteInputVariant;
    popoverTitle?: string;
    popoverPlaceholder?: string;
}

export const AutoCompleteSearch: React.FC<IAutocompleteSearchProps<any>> = ({
    wrapperClassName = '',
    selected = [],
    onChange,
    placeholder = '',
    onSearch,
    onSelectedRemove,
    needDict = true,
    chipClassName,
    selectedOptionsClassName = '',
    inputVariant,
    popoverInputVariant,
    popoverTitle,
    popoverPlaceholder,
    ...rest
}) => {
    const [highlightIndex, setHighlightIndex] = useState<number | null>(null);

    const selectedOptions = selected
        ? selected.map((item: any, index: number) => (
            <div
                className={`flex flex-none selected-option-wrapper ${highlightIndex === selected.length - index - 1 ? 'selected-option-anim' : ''}`}
                key={`selected-option-wrapper-${selected.length - index - 1}`}
            >
                <Chip
                    sx={{fontFamily: 'DM Sans bold', fontWeight: 900, fontSize: '18px'}}
                    key={item.label}
                    onDelete={() => onSelectedRemove?.(item)}
                    className={`selected-option selected-option-${index} ph-no-capture ${chipClassName}`}
                    label={item.label}
                    clearable={true}
                />
            </div>
        ))
        : null;

    return (
        <div className={`medbox-auto-complete-search relative flex flex-col ${wrapperClassName}`}>
            <AdvancedAutoComplete
                loadOptionsList={onSearch}
                placeholder={placeholder}
                onSelect={option => {
                    onChange(option);
                    setHighlightIndex(selected?.length || 0);
                }}
                inputVariant={inputVariant}
                needDict={needDict}
                popoverTitle={popoverTitle}
                popoverInputVariant={popoverInputVariant}
                error
                popoverPlaceholder={popoverPlaceholder || placeholder}
                {...rest}
            />
            {selectedOptions && selectedOptions.length > 0 && <div className={`selected-options flex flex-row flex-wrap justify-start gap-[10px] mt-[10px] sm:mt-[15px] ${selectedOptionsClassName}`}>{selectedOptions}</div>}
        </div>
    );
};
